





































































import { Vue, Component } from "vue-property-decorator";
import Navbar from "@/modules/home/components/Navbar.vue";
import Password from "vue-password-strength-meter";
import API from "@/axios";
import { namespace } from "vuex-class";
import { InviteSenderPayload, InviteSender } from "@/modules/team/types";

const Team = namespace("team");

@Component({
  components: {
    navbar: Navbar,
    password: Password,
  },
})
export default class extends Vue {
  @Team.Action("getInviteSender") getInviteSender!: (
    payload: InviteSenderPayload
  ) => void;
  @Team.Getter("getInviteSender") inviteSender: InviteSender;
  token = "";
  email = "";
  loading = false;
  isTokenExpired = false;
  isDisabled = true;
  password = "";

  beforeMount() {
    const { token, email } = this.$route.query;
    if (token && email) {
      this.token = token as string;
      this.email = email as string;
    } else {
      this.$router.push({ name: "dashboard" });
    }
  }
  capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  mounted() {
    this.getInviteSender({
      token: this.token,
      email: this.email,
    });
  }
  goBack() {
    this.$router.push({ name: "dashboard" });
  }
  checkScore(score) {
    if (score > 0) {
      this.isDisabled = false;
    }
  }
  acceptInvitation() {
    this.loading = true;
    //Token contains the invitation ID
    API.post(`/invitations/${this.token}/confirm`, {
      password: this.password,
    })
      .then(() => {
        this.loading = false;
        this.$router.push({ name: "dashboard" });
      })
      .catch(() => {
        this.loading = false;
        this.isTokenExpired = true;
      });
  }
}
